<template>
    <div class="loader-container">
        <div class="loader">
            <font-awesome-icon :icon="['fas', 'spinner']" spin class="loader-icon" />
            <p class="loader-text">{{ $translate('Loading, please wait...') }}</p>
        </div>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
    name: "ApiLoader",
    components: {
        FontAwesomeIcon
    }
};
</script>

<style scoped>
.loader-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 1;
    background-color: rgb(255 255 255);
}

.loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.5s ease-in-out;
}

.loader-icon {
    font-size: 3rem;
    /* Large Font Awesome spinner */
    color: #4caf50;
    /* Customize the color */
    margin-bottom: 1rem;
}

.loader-text {
    font-size: 1.25rem;
    color: #555;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Optional bounce animation for the spinner */
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>